import { inject, Injectable } from '@angular/core';
import { ApolloQueryResult, MutationOptions, OperationVariables, QueryOptions } from '@apollo/client/core';
import { Apollo, MutationResult } from 'apollo-angular';
import { Observable } from 'rxjs';
import { ServerName } from '../enums/server-name.enum';
import { EmptyObject } from '../types/empty-object.type';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';

export type ResultQuery<T> = Observable<ApolloQueryResult<T>>;
export type ResultMutation<T> = Observable<MutationResult<T>>;

@Injectable({ providedIn: 'root' })
export class GraphQLService {
  private readonly _apollo = inject(Apollo);
  private readonly _authenticationService = inject(AuthenticationService);

  query<QueryResult, Variables extends OperationVariables = EmptyObject>(
    options: QueryOptions<Variables, QueryResult>,
    servername = ServerName.ContractorGraphQL
  ): ResultQuery<QueryResult> {
    return this._apollo.use(servername).query<QueryResult, Variables>({
      ...options,
      context: {
        headers: {
          Authorization: `Bearer ${this._authenticationService.accessToken()}`,
        },
      },
    });
  }

  mutate<MutationResult, Variables extends OperationVariables = EmptyObject>(
    options: MutationOptions<MutationResult, Variables>,
    servername = ServerName.ContractorGraphQL
  ): ResultMutation<MutationResult> {
    return this._apollo.use(servername).mutate<MutationResult, Variables>({
      ...options,
      context: {
        headers: {
          Authorization: `Bearer ${this._authenticationService.accessToken()}`,
        },
      },
    });
  }
}
